// eslint-disable no-unused-vars
import React, { useState } from "react";
import Box from "@mui/material/Box";
import "./Loader.css";
import { Backdrop } from "@mui/material";
//eslint-disable no-unused-vars
const Loader = () => {
  const [open, setOpen] = useState(true);

  return (
    <div className="preloader">
      <div id="container">
        <div className="circle"></div>
        <div className="loader1"></div>
        <div className="loader2"></div>
        <div className="loader3"></div>
        <div className="loader4"></div>
      </div>
    </div>
  );
};

export default Loader;